import {
  inject,
  NgModule,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxEchartsModule } from 'ngx-echarts';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideNgxMask } from 'ngx-mask';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { i18nFileSuffix } from './core/i18n/i18n-file-suffix';
import { ptBrPaginatorIntl } from './core/i18n/paginator-intl';

function initializeTranslations() {
  const translate = inject(TranslateService);
  translate.addLangs(['pt-BR', 'en-US', 'es']);
  translate.setFallbackLang('pt-BR');
  return translate.use('pt-BR');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule.forRoot(),
    LayoutModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
    TranslateModule.forRoot(),
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    ...provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: i18nFileSuffix(),
      useHttpBackend: true,
    }),
    provideAppInitializer(initializeTranslations),
    { provide: MatPaginatorIntl, useFactory: ptBrPaginatorIntl },
    provideNgxMask(),
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 5000,
      extendedTimeOut: 3000,
      closeButton: true,
      progressBar: true,
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
